import React from 'react'
import './AddToHomeScreen.scss'
import {assetUrl} from "../../serviceApi";

const close =  assetUrl+'images/wrong_image.svg'
const logo = assetUrl+'images/CoreIcon.png'
const illustration = assetUrl+'images/add-to-homescreen_illustration.png'
const arrow = assetUrl+'images/arrow-white-md.png'

const AddToHomeScreen = (props) => {
	return (
		<div className={"add-to-home-main d-flex justify-content-between flex-column px-4"}>
			<div className={"header"}>
				<img src={close} alt={"alt"} className={"close-icon"} onClick={()=>props.close()}/>
				<p className={"title text-center"}>NETA</p>
			</div>
			<div className={"middle-content"}>
				<img src={logo} alt={"alt"} className={"main-logo mb-4"}/>
				<p className={"heading mb-1"}>NETA</p>
				<p className={"sub-text mb-0"}>netaapp.com</p>
			</div>
			<div className={"bottom-content "}>
				<div className={"card-box mx-auto d-flex justify-content-between"}>
					<p className={"card-text mb-0 text-left"}>Save time by adding Neta widget to your homescreen and skip going through
						the sign up process everytime.</p>
					<img src={illustration} alt={"alt"} className={"card-image"}/>
				</div>
				<button className={"button mb-4 d-flex justify-content-center align-items-center"}
					onClick={props.submit}
				>
					<p className={"mb-0"}>Add to Homescreen</p>
					<img src={arrow} alt className={"icon"}/>
				</button>
			</div>

		</div>
	)
}

export default AddToHomeScreen
